export const ENABLE_MASTER_INITIAL_SETUP = true;
export const REDIRECT_ROUTE_AFTER_MASTER_INITIAL_SETUP = "/app/schedule";
